/**
 * Represents the data required to send an email notification.
 * Matches the backend NotificationRequestDto.
 */
export interface INotificationRequest {
  to: string;
  cc?: string[];
  bcc?: string[];
  subject: string;
  body: string;
  isHtml?: boolean;
  templateName?: AvailableTemplates;
  templateVariables?: { [key: string]: any };
  attachmentUrls?: string[];
}

export enum AvailableTemplates {
  WELCOME = "welcome",
  CONTACT_US = "contact_us",
  CONTACT_US_FEEDBACK = "contact_us_feedback",
}
